"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
exports.HTMLTextNode = (props, children) => (hyperapp_1.h("span", { oncreate: el => (el.innerHTML = props.text), onupdate: el => (el.innerHTML = props.text) }));
//# sourceMappingURL=html-text-node.js.map